import { isSameOrAfter } from '@fora-monorepo/date-utils';

export const isDateAftermonthlyReportingReleaseDate = (dateString: string, monthlyReportingReleaseDate: string) => {
  return isSameOrAfter(dateString, monthlyReportingReleaseDate);
};
